import logo from './logo.svg';
import './App.css';
import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";


function App() {
  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 3,
    speed: 500,
    rows: 2,
    slidesPerRow: 2
  };
  return (
    <iframe allowfullscreen="allowfullscreen" scrolling="no" class="fp-iframe" style={{border: "1px solid lightgray", width: "100%", height: "100vh"}}
     src="https://heyzine.com/flip-book/3878c65345.html"></iframe>

    // <div style={{height:'100vh', overflow:'hidden'}}>

    //   <Slider {...settings}>
    //       <div>
    //         <div style={{display:'flex',alignItems:'center', justifyContent:'center', overflow:'hidden', height:'100vh'}}> 
    //       <img src={"https://res.cloudinary.com/blst/image/upload/v1672652448/kalender/1_Cover_Project_Kalender_1.png"} height="500" width="800" style={{height:'35vh', width:'90vw', overflow:'hidden', alignContent:'center', alignItems:'center', justifyContent:'center'}} />
    //         </div>
    //       </div>
    //       <div>
    //        <div style={{display:'flex',alignItems:'center', justifyContent:'center', overflow:'hidden', height:'100vh'}}>
    //       <img src={"https://res.cloudinary.com/blst/image/upload/v1672652448/kalender/2_Cover_2_Project_Kalender_1.png"} height="500" width="800" style={{height:'35vh', width:'90vw', overflow:'hidden', alignContent:'center', alignItems:'center', justifyContent:'center'}} />
    //         </div>
    //       </div>
    //       <div>
    //        <div style={{display:'flex',alignItems:'center', justifyContent:'center', overflow:'hidden', height:'100vh'}}>
    //       <img src={"https://res.cloudinary.com/blst/image/upload/v1672652446/kalender/3_Project_Kalender_Januari_BLST_1.png"} height="500" width="800" style={{height:'35vh', width:'90vw', overflow:'hidden', alignContent:'center', alignItems:'center', justifyContent:'center'}} />
    //         </div>
    //       </div>
    //       <div>
    //        <div style={{display:'flex',alignItems:'center', justifyContent:'center', overflow:'hidden', height:'100vh'}}>
    //       <img src={"https://res.cloudinary.com/blst/image/upload/v1672652450/kalender/4_Project_Kalender_February_Botani_Seed_1.png"} height="500" width="800" style={{height:'35vh', width:'90vw', overflow:'hidden', alignContent:'center', alignItems:'center', justifyContent:'center'}} />
    //         </div>
    //       </div>
    //       <div>
    //        <div style={{display:'flex',alignItems:'center', justifyContent:'center', overflow:'hidden', height:'100vh'}}>
    //       <img src={"https://res.cloudinary.com/blst/image/upload/v1672652471/kalender/5_Project_Kalender_March_IPB_Training_1.png"} height="500" width="800" style={{height:'35vh', width:'90vw', overflow:'hidden', alignContent:'center', alignItems:'center', justifyContent:'center'}} />
    //         </div>
    //       </div>
    //       <div>
    //        <div style={{display:'flex',alignItems:'center', justifyContent:'center', overflow:'hidden', height:'100vh'}}>
    //       <img src={"https://res.cloudinary.com/blst/image/upload/v1672652448/kalender/6_Project_Kalender_April_IPB_Press_1.png"} height="500" width="800" style={{height:'35vh', width:'90vw', overflow:'hidden', alignContent:'center', alignItems:'center', justifyContent:'center'}} />
    //         </div>
    //       </div>
    //       <div>
    //        <div style={{display:'flex',alignItems:'center', justifyContent:'center', overflow:'hidden', height:'100vh'}}>
    //       <img src={"https://res.cloudinary.com/blst/image/upload/v1672652448/kalender/7_Project_Kalender_May_Fits_1.png"} height="500" width="800" style={{height:'35vh', width:'90vw', overflow:'hidden', alignContent:'center', alignItems:'center', justifyContent:'center'}} />
    //         </div>
    //       </div>
    //       <div>
    //        <div style={{display:'flex',alignItems:'center', justifyContent:'center', overflow:'hidden', height:'100vh'}}>
    //       <img src={"https://res.cloudinary.com/blst/image/upload/v1672652473/kalender/8_Project_Kalender_June_Prima_Kelola_1.png"} height="500" width="800" style={{height:'35vh', width:'90vw', overflow:'hidden', alignContent:'center', alignItems:'center', justifyContent:'center'}} />
    //         </div>
    //       </div>
    //       <div>
    //        <div style={{display:'flex',alignItems:'center', justifyContent:'center', overflow:'hidden', height:'100vh'}}>
    //       <img src={"https://res.cloudinary.com/blst/image/upload/v1672652437/kalender/9_Project_Kalender_July_IPB_Convention_Hotel_1.png"} height="500" width="800" style={{height:'35vh', width:'90vw', overflow:'hidden', alignContent:'center', alignItems:'center', justifyContent:'center'}} />
    //         </div>
    //       </div>
    //       <div>
    //        <div style={{display:'flex',alignItems:'center', justifyContent:'center', overflow:'hidden', height:'100vh'}}>
    //       <img src={"https://res.cloudinary.com/blst/image/upload/v1672652439/kalender/10_Project_Kalender_August_BPRS_1.png"} height="500" width="800" style={{height:'35vh', width:'90vw', overflow:'hidden', alignContent:'center', alignItems:'center', justifyContent:'center'}} />
    //         </div>
    //       </div>
    //       <div>
    //        <div style={{display:'flex',alignItems:'center', justifyContent:'center', overflow:'hidden', height:'100vh'}}>
    //       <img src={"https://res.cloudinary.com/blst/image/upload/v1672652410/kalender/11_Project_Kalender_September_Serambi_Botani_1.png"} height="500" width="800" style={{height:'35vh', width:'90vw', overflow:'hidden', alignContent:'center', alignItems:'center', justifyContent:'center'}} />
    //         </div>
    //       </div>
    //       <div>
    //        <div style={{display:'flex',alignItems:'center', justifyContent:'center', overflow:'hidden', height:'100vh'}}>
    //       <img src={"https://res.cloudinary.com/blst/image/upload/v1672652420/kalender/12_Project_Kalender_October_BMTI_1.png"} height="500" width="800" style={{height:'35vh', width:'90vw', overflow:'hidden', alignContent:'center', alignItems:'center', justifyContent:'center'}} />
    //         </div>
    //       </div>
    //       <div>
    //        <div style={{display:'flex',alignItems:'center', justifyContent:'center', overflow:'hidden', height:'100vh'}}>
    //       <img src={"https://res.cloudinary.com/blst/image/upload/v1672652438/kalender/13_Project_Kalender_November_BLST_HUT_1.png"} height="500" width="800" style={{height:'35vh', width:'90vw', overflow:'hidden', alignContent:'center', alignItems:'center', justifyContent:'center'}} />
    //         </div>
    //       </div>
    //       <div>
    //        <div style={{display:'flex',alignItems:'center', justifyContent:'center', overflow:'hidden', height:'100vh'}}>
    //       <img src={"https://res.cloudinary.com/blst/image/upload/v1672652445/kalender/14_Project_Kalender_December_IICC_1.png"} height="500" width="800" style={{height:'35vh', width:'90vw', overflow:'hidden', alignContent:'center', alignItems:'center', justifyContent:'center'}} />
    //         </div>
    //       </div>
    //       <div>
    //        <div style={{display:'flex',alignItems:'center', justifyContent:'center', overflow:'hidden', height:'100vh'}}>
    //       <img src={"https://res.cloudinary.com/blst/image/upload/v1672652408/kalender/15_Back_Cover_2_Project_Kalender_1.png"} height="500" width="800" style={{height:'35vh', width:'90vw', overflow:'hidden', alignContent:'center', alignItems:'center', justifyContent:'center'}} />
    //         </div>
    //       </div>
    //       <div>
    //        <div style={{display:'flex',alignItems:'center', justifyContent:'center', overflow:'hidden', height:'100vh'}}>
    //       <img src={"https://res.cloudinary.com/blst/image/upload/v1672652409/kalender/16_Back_Cover_Project_Kalender_1.png"} height="500" width="800" style={{height:'35vh', width:'90vw', overflow:'hidden', alignContent:'center', alignItems:'center', justifyContent:'center'}} />
    //         </div>
    //       </div>


    //     </Slider>

    //   </div>
        
  );
}

export default App;
